import { HEADER_CONSTANTS } from "../constants"

/**
 * 判断是否为根路径
 * @description 检查路径是否为根路径（去除语言前缀后）
 * @param pathname - 要检查的路径
 * @returns 是否为根路径
 *
 * @example
 * isRootPath("/") // true
 * isRootPath("/zh") // true
 * isRootPath("/en/") // true
 * isRootPath("/zh/about") // false
 */
export function isRootPath(pathname: string): boolean {
  const pathWithoutLocale = pathname.replace(HEADER_CONSTANTS.LOCALE_PATH_REGEX, HEADER_CONSTANTS.ROOT_PATH)
  return pathWithoutLocale === HEADER_CONSTANTS.ROOT_PATH || pathname === HEADER_CONSTANTS.ROOT_PATH
}
